export const runtimeDisqualificationFromProjection = ({
  projection,
  questionnaire,
  fallbackQuestion = null,
}) => {
  if (projection?.state !== "disqualified") return null;
  const contract = projection.disqualification || {};
  const legacyRejected = (
    projection.matching?.rejected_programs || []
  ).find((item) => item?.question_id || item?.source_node_id) || {};
  const sourceNodeId = (
    contract.source_node_id
    || legacyRejected.source_node_id
    || legacyRejected.question_id
    || null
  );
  const sourceQuestion = (questionnaire?.questions || []).find((question) => (
    [question.id, question.source_id, question.release_node_id]
      .filter(Boolean)
      .some((value) => String(value) === String(sourceNodeId))
  )) || fallbackQuestion;
  return {
    disqualified: true,
    code: contract.code || "no_program_matches",
    reason: (
      contract.message
      || "Your current information does not match an available treatment."
    ),
    action: contract.action || null,
    reversible: contract.reversible !== false,
    failedStage: contract.failed_stage || null,
    reasonCode: contract.reason_code || null,
    disqualifyingCondition: "treatment_runtime_authority",
    backState: projection.back_state || null,
    questionId: sourceQuestion?.id || null,
    sourceQuestionId: sourceNodeId,
  };
};

export const runtimeDisqualificationActionLabel = (reason) => (
  reason?.reversible === false
    ? reason?.action?.label || "Start a new assessment"
    : "Back"
);
